import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const packs = ['Pack Baby Shower', 'Pack Bautismo & Comunión', 'Pack Aros Decorativos', 'Pack Deco Infantil', 'Pack San Valentín', 'Pack Café', 'Pack Diseños', 'Pack Escolares', 'Pack Flores', 'Pack Halloween', 'Pack Letras', 'Pack Mini Letras', 'Pack Navidad', 'Pack Números', 'Pack Pascuas'];
export function IncludedPacks() {
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto bg-brand-bg" data-id="element-94">
      <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-14" data-id="element-95">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl text-brand-text font-bold leading-tight mb-4" data-id="element-96">
          Packs incluidos en tu Mega Kit Completo
        </h2>
        <p className="text-base sm:text-lg text-brand-text-muted font-medium" data-id="element-97">
          Una colección inmensa para crear regalos personalizados, decoración,
          nombres, letras, piezas para eventos y fechas especiales. ¡Ideal para
          vender o regalar!
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-98">
        {packs.map((pack, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.05
      }} className="bg-brand-pink-light rounded-2xl p-4 sm:p-6 flex items-center gap-4 shadow-sm border border-brand-pink/30 hover:shadow-md transition-shadow" data-id="element-99">
            <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center shrink-0 shadow-sm" data-id="element-100">
              <CheckCircle2 className="w-6 h-6 text-brand-cta" data-id="element-101" />
            </div>
            <span className="font-serif font-bold text-brand-text text-lg" data-id="element-102">
              {pack}
            </span>
          </motion.div>)}
      </div>
    </section>;
}